import { useEffect, useState } from 'react'
import React from 'react'
import './recomendados.css'
import bt_orange from '../../../assets/imgs/nuevo_libro/bt_orange.png'
import { useTranslation } from "react-i18next";
import Stars from '../../../assets/imgs/libro_verde/Stars.png'

import Modalibro from '../../../components/modalLibro/ModalLibro';
import VideoPopup from '../../popup/videopopup';


const Recomendados = () => {
    const [over, setOver] = useState(true);
    const [over2, setOver2] = useState(false);
    const [over3, setOver3] = useState(false);
    
    const img1 = 'https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/Play.svg';

    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("librVerd");
    const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);
    const [currentVideoId, setCurrentVideoId] = useState(null);

    const openVideoPopup = (videoId) => {
        setCurrentVideoId(videoId);
        setVideoPopupOpen(true);
      };
    
      const closeVideoPopup = () => {
        setVideoPopupOpen(false);
      };

    const [qty, setQty] = useState(1);
    const initial = 1;
    const max = 3;
    const nextCard = (num) => {
        if ((qty+num) < initial) {
            setQty(initial);            
        }else if ((qty+num) < max) {
            setQty(qty + num);
        } else {
            setQty(max);            
        }
        switch (qty+num) {
            case 1:
                setOver(true);
                setOver2(false);
                setOver3(false);
                break;
            case 2:
                setOver2(true);
                setOver(false);
                setOver3(false);
                break;
            case 3:
                setOver3(true);
                setOver2(false);
                setOver(false);
                break;
        }
    };
  
    return (
    <div class="NLV_recomendados">
        <h3 class="NLV_recomendados_title">Ellos lo recomiendan</h3>
         <VideoPopup  isOpen={isVideoPopupOpen} onClose={closeVideoPopup} videoURL={currentVideoId} />
        <div id='NLV_card1'  className={over ? 'active NLV_recomendado_card fadeIn animated' : 'NLV_recomendado_card'}>
            <div class="NLV_recomendado_img" onClick={() => openVideoPopup('https://www.youtube.com/embed/J8_6RIyl4W8?si=AvtQCOl2tWwDB8cX')} >
                <img class="NLV_recomendado_img1" src='https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/reviews/poster-review-1.jpg'
                 
                />
            </div>
            <div class="NLV_recomendados_txt">
                <h3>Ninfa Salinas</h3>
                <h4>{(t('recomendados.pers1'))}</h4>
                <img src={Stars}/>
                <p>{(t('recomendados.opini1'))}</p>
            </div>
        </div>
        <div id='NLV_card2'  className={over2 ? 'active NLV_recomendado_card fadeIn animated' : 'NLV_recomendado_card'}>
            <div class="NLV_recomendado_img"  onClick={() => openVideoPopup('https://www.youtube.com/embed/XVRZh9ym2Do?si=U-pyYLHFjk0uDeUO')}>
                <img class="NLV_recomendado_img1" 
                
                src='https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/reviews/poster-review-2.jpg'/>
            </div>
            <div class="NLV_recomendados_txt">
                <h3>Fernando Suinaga</h3>
                <h4>{(t('recomendados.pers2'))}</h4>
                <img src={Stars}/>
                <p>{(t('recomendados.opini2'))}</p>
            </div>
        </div>
        <div id='NLV_card3'  className={over3 ? 'active NLV_recomendado_card fadeIn animated' : 'NLV_recomendado_card'}>
            <div class="NLV_recomendado_img"  onClick={() => openVideoPopup('https://www.youtube.com/embed/6hYPvGH2a3M?si=dHbpk6P_Tt08LqdM')} >
                <img class="NLV_recomendado_img1" 
                
                src='https://www.ricardosalinas.com/Content/assets/img/libros/lanzamiento/reviews/poster-review-3.jpg'/>
            </div>
            <div class="NLV_recomendados_txt">
                <h3>Dean Kamen</h3>
                <h4>{(t('recomendados.pers3'))}</h4>
                <img src={Stars}/>
                <p>{(t('recomendados.opini3'))}</p>
            </div>
        </div>
        <div class="NLV_coment_arrows_movil">
             <a onClick={() => nextCard(-1)}>
                <img class="NLV_coment_show_arrowL_movil" src='/assets/imgs/detalle_blog/arrow.png'/>
            </a>
             <a onClick={() => nextCard(+1)}>
                <img class="NLV_coment_show_arrowL_movil" src='/assets/imgs/detalle_blog/arrow.png'/>
            </a>
        </div>
        <div class="NLV_recomendados_frase">
            <h4>
                {(t('recomendados.frase1'))}
                <br/>
                {(t('recomendados.frase2'))}
            </h4>
            <p style={{color:'#f3b640'}}>
                - Ricardo Salinas
            </p>
        </div>
    </div>
  )
}

export default Recomendados
